document.addEventListener("DOMContentLoaded", function () {
    $("#check_terms").click(function () {
        $("#submitBtn").toggleClass("btn-deny");
    });

    $('#contact-event-form').submit(function (e) {
        e.preventDefault();
        let spinnerFrame = document.querySelector('.spinner-frame');
        let spinner = document.querySelector('.custom-spinner');
        $('#contact-event-section').addClass('invisible');
        spinnerFrame.style.display= "flex";
        spinner.style.display= "block";
        console.log('clic');
        $.ajax({
            url: "https://pro.lineheart.lu/api/sendEventShopify/",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                name: $('#contact-nom').val(),
                first_name: $('#contact-prenom').val(),
                phone: $('#contact-phone').val(),
                email: $('#contact-email').val(),
                school: $('#contact-school').val(),
                note: $('#contact-message').val(),
                template: $('#template').val(),
                emails: $('#emails').val(),
            }),
            success: function (result){
                console.log(result);
                spinner.style.display= "none";
                spinnerFrame.style.display= "none";
                $('#success-response').removeClass('invisible');
            },
            error: function (error){
                console.log(error);
                spinner.style.display= "none";
                spinnerFrame.style.display= "none";
                $('#error-response').removeClass('invisible');
            }
        });
    });

});